import styled, { css } from 'styled-components';
import { fillAbsolute, objectFitEdge, secondaryAnimatedPlaceholder } from '../../../../theme/mixins';
import { LazyLoadImage } from '../../../../shared/components/lazyLoadImage';
import { LazyLoadVideo } from '../../../../shared/components/lazyLoadVideo';

export const Container = styled.div``;

export const Video = styled(LazyLoadVideo).attrs(() => ({
  placeholderStyle: css`
    height: 100%;
    ${secondaryAnimatedPlaceholder};
  `,
}))`
  ${objectFitEdge};
  object-fit: cover;
`;

export const Image = styled(LazyLoadImage).attrs(() => ({
  placeholderStyle: css`
    height: 100%;
    ${secondaryAnimatedPlaceholder};
  `,
}))`
  ${fillAbsolute};
  object-fit: cover;
`;
